export default {
  text1: 'Om veiligheidsredenen mogen we je niet langer dan ',
  text2: ' minuten ingelogd houden als je inactief bent',
  logout: 'Uitloggen',
  refresh: 'Vernieuwen'
};
